// extracted by mini-css-extract-plugin
export default {"pos-sync__container":"styles_pos-sync__container__9S98X","title":"styles_title__8E31Q"};